import { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Row } from 'react-bootstrap';
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import Download from '../MainSection/Download/Download';
import AdvanceFilterTable from './AdvanceFilterTable';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsRolesAdvanceFilterData } from '../../redux/action';

const AdvanceFilter = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const location = useLocation();
    const { page, rowsPerPage, advancedExpression, pageName } = location.state || {}; // ✅ only values

    // use local state for setters
    const [currentPage, setPage] = useState(page || 0);
    const [currentRowsPerPage, setRowsPerPage] = useState(rowsPerPage || 20);
    // const tableData = state?.getRolesAdvanceFilterData || [];
    const { getRolesAdvanceFilterData } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (advancedExpression) {   // only call after filter applied
            setLoading(true);
            dispatch(
                loadSettingsRolesAdvanceFilterData(
                    setLoading,
                    advancedExpression,
                    currentRowsPerPage,
                    currentPage,
                    pageName
                )
            );
        }
    }, [advancedExpression, currentRowsPerPage, currentPage, dispatch]);

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Filtered Data"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Filtered Data</span>
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <AdvanceFilterTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                tableData={getRolesAdvanceFilterData}
                                loading={loading}
                                setLoading={setLoading}
                                totalDataCount={totalDataCount}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                                rowsPerPage={currentRowsPerPage}
                            />
                        </div>
                    </div>
                </div>
            </Main>
        </div >
    );
};

export default AdvanceFilter;